import { cva, type VariantProps } from "class-variance-authority";
import type React from "react";
import { cn } from "../../lib/utils";

const rowVariants = cva("row relative grid grid-cols-12 gap-unit");

interface RowProps
  extends VariantProps<typeof rowVariants>,
    Omit<React.HTMLAttributes<HTMLDivElement>, "className"> {
  children: React.ReactNode;
  className?: string;
}

/**
 * row component with 12 grid columns
 * @param props
 * @constructor
 */
export function Row({ children, className, ...props }: RowProps) {
  const classes = cn(rowVariants({ className }));

  return (
    <div className={classes} data-testid="row" {...props}>
      {children}
    </div>
  );
}
